import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'SmileCore',
  brandName: 'SmileCore',
  description: 'Sistema de agendamento para dentistas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Consultório dentário moderno',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Dentista atendendo paciente',
  },
  testimonials: [
    {
      name: 'Dr. André Sousa',
      role: 'Médico Dentista',
      text: 'O SmileCore otimizou a marcação de consultas na minha clínica. Menos tempo ao telefone, mais tempo com os pacientes.',
      image: testimonial1,
    },
    {
      name: 'Mariana Lima',
      role: 'Paciente',
      text: 'Adoro poder marcar as minhas consultas online, ver os horários disponíveis e receber lembretes. Super prático!',
      image: testimonial2,
    },
    {
      name: 'Clínica Sorriso',
      role: 'Gestão da Clínica',
      text: 'Reduzimos drasticamente as faltas às consultas com os lembretes automáticos. Um sistema indispensável.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'dentista',
    professionals: 'dentistas',
    business: 'clínica',
    businesses: 'clínicas',
    service: 'tratamento',
    services: 'tratamentos',
    client: 'paciente',
    clients: 'pacientes',
    appointment: 'consulta',
    appointments: 'consultas',
  },
  homepage: {
    hero: {
      badge: 'Solução Completa',
      title: 'Simplifique seus agendamentos com SmileCore',
      description: 'Aumente a produtividade e ofereça a melhor experiência aos seus pacientes com o SmileCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
    },
    statistics: [
      { value: '200+', label: 'Clínicas' },
      { value: '30k+', label: 'Consultas' },
      { value: '97%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Marcações por Telefone',
        description: 'Interromper tratamentos para atender chamadas resulta em pacientes insatisfeitos e perda de concentração.',
        icon: 'PhoneCall',
        quote: {
          text: 'Perdemos em média 25 minutos por dia apenas atendendo chamadas para agendamentos',
          author: 'Dr. Maria Silva',
          business: 'Clínica Dental Silva',
        },
      },
      {
        title: 'Tempo Perdido',
        description: 'Gerir horários manualmente consome tempo que poderia usar para atender mais pacientes.',
        icon: 'Clock',
        stats: [
          { label: 'Tempo perdido por semana:', value: '7 horas' },
          { label: 'Pacientes perdidos por mês:', value: '12+' },
        ],
      },
      {
        title: 'Pacientes Ausentes',
        description: 'Faltas e cancelamentos de última hora causam prejuízos e horários vazios que poderiam ser preenchidos.',
        icon: 'Users',
        quote: {
          text: 'Reduzimos as faltas em 90% após implementar o sistema de agendamento online',
          author: 'Dr. João Costa',
          business: 'Costa Dental Care',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'SmileCore: O seu assistente digital',
      description: 'Simplificamos a gestão da sua clínica para que possa focar-se no que realmente importa.',
      features: [
        {
          title: 'Agendamento Online 24/7',
          description: 'Os seus pacientes podem marcar consultas a qualquer momento, sem precisar telefonar.',
        },
        {
          title: 'Gestão de Pacientes',
          description: 'Aceda ao histórico de consultas e tratamentos de cada paciente.',
        },
        {
          title: 'Lembretes Automáticos',
          description: 'Reduza as faltas com lembretes por email ou SMS.',
        },
      ],
    },
    testimonials: {
      title: 'O que os nossos clientes dizem',
      description: 'Dentistas que confiam no SmileCore para crescer.',
    },
    finalCta: {
      title: 'Pronto para simplificar seus agendamentos?',
      description: 'Junte-se a dentistas que já estão a crescer com o SmileCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Falar com Consultor',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de dentista',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
